import { render, staticRenderFns } from "./Magazines.vue?vue&type=template&id=63b23002&scoped=true"
import script from "./Magazines.vue?vue&type=script&lang=js"
export * from "./Magazines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b23002",
  null
  
)

export default component.exports